import { useQuery } from 'react-query'
import { apiGetRepairs } from '../api/repairs'

export const FAULT_REPORT_QUERY_KEY = 'repairs'

export const useRepairs = ({ plants, zones, startAt, endAt }) => {
  const {
    status,
    data: repairs,
    error,
    isFetching,
    isLoading,
    isError,
    isSuccess,
  } = useQuery(
    [FAULT_REPORT_QUERY_KEY, ...plants, ...zones, startAt, endAt],
    async () => {
      const result = await apiGetRepairs({
        plants,
        zones,
        startAt,
        endAt,
      })

      return result.data
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!startAt && !!endAt && !!zones,
    },
  )
  return {
    status,
    repairs,
    error,
    isFetching,
    isLoading,
    isError,
    isSuccess,
  }
}

// Annotation
